import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { AuthenticationSelectors } from '../auth/state/authentication.selectors';
import { filter, map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { CommunicationsActions } from './state/communications.actions';
import { CommunicationsSelectors } from './state/communications.selectors';
import { transition, style, animate, trigger } from '@angular/animations';
import { UserAction } from '../user/state/user.action';
import { Subscription } from 'rxjs/internal/Subscription';
import { CategoryModel } from './state/communications.model';

const enterTransition = transition(':enter', [
    style({
        opacity: 0
    }),
    animate('0.5s ease-in', style({
        opacity: 1
    }))
]);

const fadeIn = trigger('fadeIn', [
    enterTransition
]);

@Component({
    selector: 'communication',
    templateUrl: 'communications.component.html',
    animations: [
        fadeIn
    ]
})
export class CommunicationsComponent implements OnInit, OnDestroy {
    categoriesSelector$: Observable<CategoryModel>;
    selectedCategorySelector$: Observable<CategoryModel>;
    browserOpen = false;
    subscriptions = new Subscription();
    userId: number = 0;

    constructor(private authenticateSelector: AuthenticationSelectors,
                private communicationsSelector: CommunicationsSelectors,
                private store: Store<any>) {
        this.categoriesSelector$ = authenticateSelector.selectUserCustomFields()
                                        .pipe(
                                            filter(userCustomFields => userCustomFields !== undefined),
                                            map(userCustomFields => {return userCustomFields.communication.categories})
                                        );
        this.selectedCategorySelector$ = communicationsSelector.selectSelectedCategory();
        this.authenticateSelector.selectCurrentUser()
            .pipe(
                filter(currentUser => currentUser !== undefined)
            )
            .subscribe(currentUser => this.userId = currentUser.userId);
    }


    ngOnInit() {
        this.store.dispatch(UserAction.getUserCustomFields({userId: this.userId}))
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    selectCategory(selectedCategory): void {
        this.store.dispatch(CommunicationsActions.selectedCategory({selectedCategory}));
    }

    openJobBrowser(): void {
        this.browserOpen = true;
    }

    clone(): void {

    }

    saveJob(): void {}

    viewReport(): void {}
}